import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { FormsModule } from '@angular/forms';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    imports: [WebNavbarComponent, FormsModule, RouterLink, WebFooterComponent]
})
export class ContactUsComponent {
  constructor(private router: Router) { }

  redirectTo(page){
    this.router.navigate([page]);
  }
}
